// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"195":"2bf4fee5","230":"37181a54"}[chunkId] + ".js";
};